/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment, useContext, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { ImageEditContext } from "cms/images/image-selector/context/image-edit-context";
import { TabPanel } from "cms/images/image-selector/dialog-edit/panels/tab-panel";
import LabelledField from "components/labelled-field/index";
import { useSnackbar } from "hooks/useSnackbar";
import { ButtonOutlined } from "components/page-components/buttons/button-outlined";
import { SVGIcons } from "cms/icons/svg-icons";
import { useTranslation } from "react-i18next";
import { useSimplicityImage } from "cms/images/hooks/use-simplicity-image";
import { isArrayNotEmpty } from "utils/empty-exists";
import Config from "data/config";

const ImageEditPlacementsPanel = () => {

    const { showSnackbar } = useSnackbar();
    const { t } = useTranslation();
    const { getPlacements } = useSimplicityImage();

    const [placements, setPlacements] = useState([]);
    const imageEditContext = useContext(ImageEditContext);
    const selectedImage = imageEditContext?.selectedImage;
    const hasImage = imageEditContext?.hasImage;
    const localState = imageEditContext?.localState;
    const selectedEditTab = imageEditContext?.selectedEditTab;

    const guid = selectedImage?.guid;
    const copyText = selectedImage?.guid;

    useEffect(() => {
        const fetchPlacements = async (guid) => {
            const result = await getPlacements(guid);
            const placements = result?.placements;
            setPlacements(placements);
        };
        fetchPlacements(guid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [guid]);

    const onCopyToClipbaord = () => {
        navigator.clipboard.writeText(copyText);
        showSnackbar("Copied to system clipboard");
    };
    
    return (
        <Fragment>

            <TabPanel
                value={selectedEditTab}
                index={1}
                style={{ height: "100%" }}
            >

                {hasImage && (
                    <>
                        <LabelledField label="GUID" className="labelField">
                            <div className="form-id-area">
                                <p>{localState?.image?.guid}</p>
                                <ButtonOutlined
                                    className="copyButton"
                                    startIcon={<SVGIcons.common.Copy/>}
                                    onClick={onCopyToClipbaord}
                                    label={t("commons.copyToClipBoard")}
                                />
                            </div>
                        </LabelledField>

                        <LabelledField
                            label="Webpages"
                            className="labelField"
                            style={{ height: "100%" }}
                        >
                            <div style={{
                                border: "1px solid #dfdfdf",
                                borderRadius: "8px",
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                flexDirection: "column",
                                overflowY: "auto",
                                fontSize: "13px",
                                padding: "0 12px",
                            }}
                            >
                                {isArrayNotEmpty(placements) && placements.map((placement, index) => {
                                    const { webpage, title, path, placed_as } = placement;
                                    const editPage = () => {
                                        const path = `/composer/${webpage}`;
                                        window.open( path, "placements",);
                                    };
                                    return (
                                        <div
                                            key={`${webpage}${index}`}
                                            style={{ display: "flex", flexDirection: "row", width: "100%", borderBottom: "1px solid #dfdfdf" }}
                                        >
                                            <div
                                                style={{
                                                    padding: "16px",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    width: "80%",
                                                }}
                                            >
                                                <div>
                                                    <div style={{ fontWeight: "700" }}>
                                                        Title: {title}
                                                    </div>
                                                    <div style={{ color: "#bebebe" }}>
                                                        Placement Type: {placed_as}
                                                    </div>
                                                    <div>
                                                        Path: <a target='_new' href={`${Config.previewUrl}${path}`}>{path}</a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                width: "20%",
                                                // border: '1px solid red',
                                            }}
                                            >
                                                <Button
                                                    variant="outlined"
                                                    size={"small"}
                                                    onClick={editPage}
                                                >Edit</Button>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </LabelledField>
                    </>
                )}
            </TabPanel>

        </Fragment>
    );
};

export { ImageEditPlacementsPanel };
